exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".u-center-text{text-align:center}.u-margin-top-huge{margin-top:10rem}\n", ""]);
